/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const IcaR = t.interface({
  business_name: t.string,

  creditor_institution_code: t.string,

  id_ica: t.string,

  publication_date: UTCISODateFromString,

  validity_date: UTCISODateFromString
});

// optional attributes
const IcaO = t.partial({});

export const Ica = t.intersection([IcaR, IcaO], "Ica");

export type Ica = t.TypeOf<typeof Ica>;
